import { GameProps, gamePropsNull } from './game.props'
import { Game } from './game'

interface PlayingGameProps extends GameProps {
  readonly currentTrickRoundNumber: number
  readonly shouldShowRestOfTricksAreMine: boolean
  readonly shouldShowNoneOfTricksAreMine: boolean
  readonly shouldShowConfirmDeclarerHasRestOfTricks: boolean
  readonly shouldShowConfirmDeclarerHasNoneOfTricks: boolean
}

export class PlayingGame extends Game {
  public readonly shouldShowRestOfTricksAreMine =
    this.playingGameProps.shouldShowRestOfTricksAreMine

  public readonly shouldShowNoneOfTricksAreMine =
    this.playingGameProps.shouldShowNoneOfTricksAreMine

  public readonly currentTrickRound =
    this.playingGameProps.currentTrickRoundNumber

  public readonly shouldShowConfirmDeclarerHasRestOfTricks =
    this.playingGameProps.shouldShowConfirmDeclarerHasRestOfTricks

  public readonly shouldShowConfirmDeclarerHasNoneOfTricks =
    this.playingGameProps.shouldShowConfirmDeclarerHasNoneOfTricks

  public constructor(private readonly playingGameProps: PlayingGameProps) {
    super(playingGameProps)
  }
}

export const playingGameNull: PlayingGame = new PlayingGame({
  ...gamePropsNull,
  gameStatus: 'Playing',
  currentTrickRoundNumber: 0,
  shouldShowRestOfTricksAreMine: false,
  shouldShowNoneOfTricksAreMine: false,
  shouldShowConfirmDeclarerHasRestOfTricks: false,
  shouldShowConfirmDeclarerHasNoneOfTricks: false,
})
